<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  /**
   * @type {Array} list of font family names
   */
  export let dropdownItems = ["Image", "PDF"]
  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false
  /**
   * @type {String} the default or active font family in the dropdown area
   */
  export let activeItem = dropdownItems[0]
  export let dropdownClr = "hover:bg-blue-500"

  export let title

  /**
   * @type {undefined} binded the overall dropdown parent element
   */
  let dropdown
  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div class="w-max" bind:this={dropdown}>
  <button
    on:click={() => {
      showDropdown = !showDropdown
    }}
    type="button"
    class="normal-blue-dropdown-btn disabled:text-white-200/50 w-fit disabled:cursor-not-allowed disabled:bg-blue-200/50"
  >
    <span><i class="fa-solid {title == 'Download Documents' ? 'fa-download' : 'fa-envelope'}" /></span>
    &nbsp;&nbsp;
    <span class="hidden select-none sm:block">{title}</span>
    &nbsp;&nbsp;
    <span class="text-white">
      <i class="fa-solid fa-chevron-down {showDropdown ? 'rotate-180' : 'rotate-0'} " />
    </span>
  </button>

  <ul style="padding-inline-start:0px;" class:hidden={!showDropdown} class="absolute left-0 z-10 mt-1 max-h-56 w-full flex-col overflow-auto rounded-md border border-[#a0a1a580] bg-white text-base shadow-lg ring-opacity-5 focus:outline-none dark:bg-darkgray sm:text-sm" tabindex="-1">
    {#each dropdownItems as item}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li
        on:click={(e) => {
          activeItem = item
          showDropdown = false
          dispatch("change", activeItem)
        }}
        class="relative cursor-pointer select-none rounded-md p-2 text-center text-gray-d00 hover:text-white dark:text-white sm:pl-9 {dropdownClr} {item == 'email' ? 'hover:dark:text-black' : 'dark:text-white'}"
      >
        <!-- dark:hover:bg-black -->
        <div class="flex items-center">
          <div class="text-sm">{item == "PDF" || item == "Image" ? `as ${item}s ZIP` : item}</div>
        </div>
      </li>
    {/each}
  </ul>
</div>

<style lang="postcss">
  .normal-blue-dropdown-btn {
    @apply flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 md:min-w-fit;
  }
</style>
